var xP = require('../../xP');

module.exports = {
  name: 'repeat_last_button', base: 'button', prototype: {
    element_selector: '.repeat_last_button',

    init: function (params) {
      xP.controls.repeat_first_button.base.init.apply(this, arguments);

      var parent = this.parent(), repeat = parent.repeat;

      if (!(repeat instanceof xP.repeats.item)) {
        return;
      }

      this.$element.click(function () {
        //repeat.remove(parent);
        repeat.move(parent, repeat.children().length - 1);

        return false;
      });

      this.enabled = {
        on: function () {
          return repeat.children().length - 1 > parent._param('repeat_position') * 1
        },
        from: repeat
      };
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/repeats/repeat_last_button.js
 ** module id = 30
 ** module chunks = 0
 **/